module.exports = __webpack_public_path__ + "static/TT1446_TW-MKD01_r1-header-8d76243aadc4f19ee552df8c2a86c30a.png";